import { faPlusSquare } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Button, Grid, TableFooter, TablePagination } from "@material-ui/core";
import Paper from "@material-ui/core/Paper";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import "../style";
import setClassBasedOnCell from "../utils/ClassSetter";
import CustomTooltip from "../utils/CustomTooltip";
import { isAuthorized } from "./Common/CheckAuthorization";
import ToggleSwitch from "./FormElement/ToggleSwitch";
import TooltipElement from "./FormElement/TooltipElement";
import Loader from "./Loader";
import LongMenu from "./LongMenu";

//import Link from "@material-ui/core/Link";

const styles = theme => ({
  active: {
    color: "#00bc84"
  },
  dataRows: {
    height: 70
  }
});

const tooltipData = {
  inventoryUsingEstBushels: {
    formula:
      "(Incoming Field Est. Load Bushels or Incoming Est. Home Scale Shrunk Bushels) - (Outgoing Field Est. Load Bushels or Outgoing Est. Home Scale Shrunk Bushels)"
  },
  inventoryUsingReconciledBushels: {
    formula:
      "(Incoming Field Est. Load Bushels or Incoming Est. Home Scale Shrunk Bushels) - Reconciled Bushels"
  },
  balance: {
    formula: "Bushels Contracted - Field Est. Load Bushels"
  },
  payloadBalance: {
    formula: "Bushels contracted - Net Bushels Reconciled"
  }
};

const superHeaderStyle = {
  fontSize: 16,
  fontWeight: "bold",
  textAlign: "center",
  color: "#000",
  padding: 0,
  border: "1px solid",
  borderBottom: "1px solid rgba(224, 224, 224, 1)"
};
const superHeaderLastChild = {
  ...superHeaderStyle,
  textAlign: "center"
};

class CreateTable extends Component {
  state = {
    rowsPerPage: 50,
    page: 0
  };

  addSuperHeader = categoryRows => {
    const { isMenuRequired } = this.props;
    const keys = Object.keys(categoryRows);
    const colSuperHeader = keys.map((value, index) => {
      console.log(value);
      return (
        <TableCell
          key={index}
          style={
            index < keys.length - 1 ? superHeaderStyle : superHeaderLastChild
          }
          colSpan={categoryRows[value].cell}
        >
          {categoryRows[value].name}
        </TableCell>
      );
    });
    {
      isMenuRequired &&
        isAuthorized() &&
        colSuperHeader.push(<TableCell key="longMenu"> </TableCell>);
    }
    return <TableRow key={colSuperHeader}>{colSuperHeader}</TableRow>;
  };
  addHeaderRow = headerRows => {
    const {
      order,
      orderBy,
      onRequestSort,
      classes,
      isMenuRequired = true,
      isSortingRequired = true,
      isBorder = false
    } = this.props;
    const createSortHandler = property => event => {
      onRequestSort(event, property);
    };
    const columnHeader = Object.keys(headerRows).map((value, index) => {
      return (
        <TableCell
          key={index}
          style={{
            padding: "0px 0px 0px 15px",
            fontSize: 14,
            fontWeight: "bold",
            border: isBorder ? "1px solid" : "",
            borderBottom: "1px solid rgba(224, 224, 224, 1)"
          }}
        >
          <TableSortLabel
            active={orderBy === value}
            direction={order}
            onClick={isSortingRequired && createSortHandler(value)}
          >
            {value === "inventoryUsingEstBushels" ||
            value === "inventoryUsingReconciledBushels" ||
            value === "balance" ||
            value === "payloadBalance" ? (
              <CustomTooltip
                title={tooltipData[value].formula}
                aria-label="View"
              >
                <span>{headerRows[value]}</span>
              </CustomTooltip>
            ) : (
              headerRows[value]
            )}
          </TableSortLabel>
        </TableCell>
      );
    });
    {
      isMenuRequired &&
        isAuthorized() &&
        columnHeader.push(<TableCell key="longMenu"> </TableCell>);
    }
    return <TableRow key={columnHeader}>{columnHeader}</TableRow>;
  };

  desc = (a, b, orderBy) => {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  };

  stableSort = (array, cmp) => {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = cmp(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map(el => el[0]);
  };

  getSorting = (order, orderBy) => {
    return order === "desc"
      ? (a, b) => this.desc(a, b, orderBy)
      : (a, b) => -this.desc(a, b, orderBy);
  };

  sortData = rowData => {
    return this.stableSort(
      rowData,
      this.getSorting(this.props.order, this.props.orderBy)
    );
  };

  addDataRow = (rowData, headerRows, clickable) => {
    if (rowData.length === 0) {
      return (
        <TableRow key="no-data">
          <TableCell align="center" colSpan={Object.keys(headerRows).length}>
            No data Available
          </TableCell>
        </TableRow>
      );
    }
    const rowsCollection = rowData.map((value, index) => {
      if (!value.disabled || value.disabled === "false") {
        return (
          <TableRow
            className={this.props.classes.dataRows}
            style={{
              cursor: clickable ? "pointer" : "normal"
            }}
            key={value.id ? `${value.id}_${index}` : index}
            onClick={
              this.props.onClick &&
              (() =>
                this.props.onClick(
                  value.id,
                  value.contractNumber,
                  value.storageIds,
                  value.onsiteStorage,
                  value.commodity
                ))
            }
          >
            {this.addDataColumn(value, headerRows, clickable)}
          </TableRow>
        );
      }
      return false;
    });
    return rowsCollection;
  };
  addDataColumn = (columnData, headerRows, clickable) => {
    const { isMenuRequired = true, isBorder } = this.props;
    const columnCollection = Object.keys(headerRows)
      .filter(
        key =>
          Object.keys(columnData).indexOf(key) !== -1 ||
          Object.keys(columnData).indexOf("id") !== -1 ||
          Object.keys(columnData).indexOf("disabled") !== -1
      )
      .map((value, index) => {
        return (
          <TableCell
            style={{
              padding: "0px 0px 0px 15px",
              fontSize: 14,
              cursor: clickable ? "pointer" : "normal",
              border: isBorder ? "1px solid" : "",
              borderBottom: "1px solid rgba(224, 224, 224, 1)"
            }}
          >
            <Grid
              style={{
                display: "flex",
                alignItems: "center"
              }}
            >
              <span className={setClassBasedOnCell(value, columnData)}>
                {value === "enabled" || value === "enable" ? (
                  <ToggleSwitch
                    id={columnData["id"]}
                    fieldName={columnData["fieldName"]}
                    value={columnData[value]}
                    disabled={
                      columnData["modifiable"] !== undefined
                        ? !columnData["modifiable"]
                        : false
                    }
                    onToggle={this.props.toggle}
                  />
                ) : value === "fields" || value === "indicators" ? (
                  columnData[value] ? (
                    <Link
                      component="button"
                      onClick={
                        this.props.edit &&
                        (() => this.props.edit(columnData.id))
                      }
                      to={`${this.props.loc}/${value}`}
                    >
                      <CustomTooltip title={`View ${value}`} aria-label="View">
                        <Button style={{ color: "blue" }}>
                          {columnData[value]}
                        </Button>
                      </CustomTooltip>
                    </Link>
                  ) : isAuthorized() ? (
                    <Link
                      to={`${this.props.loc}/${value}/create`}
                      onClick={
                        this.props.edit &&
                        (() => this.props.edit(columnData.id))
                      }
                    >
                      <CustomTooltip title={`Add ${value}`} aria-label="Add">
                        <Button style={{ color: "#00bc84" }}>
                          <FontAwesomeIcon size="1x" icon={faPlusSquare} />
                        </Button>
                      </CustomTooltip>
                    </Link>
                  ) : (
                    <Button style={{ pointerEvents: "none" }}>-</Button>
                  )
                ) : (
                  (value === "updatedBy" && (
                    <CustomTooltip title={columnData[value]}>
                      <span>
                        {(columnData[value] === "script"|| !columnData[value])
                          ? "NIL"
                          : columnData[value].toString().substring(0, 9)}
                      </span>
                    </CustomTooltip>
                  )) ||
                  (columnData[value] || columnData[value] === 0
                    ? columnData[value]
                    : "NIL")
                )}
              </span>
              {value === "maturityDate" &&
                columnData["daysLeft"] < 3 &&
                columnData["contractStage"] != "Complete" && (
                  <TooltipElement columnData={columnData} />
                )}
              {/* {value === "updatedBy" && columnData[value].toString().slice(-2)} */}
            </Grid>
          </TableCell>
        );
      });

    {
      isMenuRequired &&
        isAuthorized() &&
        columnCollection.push(
          <TableCell
            style={{
              padding: "5px"
            }}
            key=""
          >
            <LongMenu
              forDelete={this.props.delete || ""}
              currentId={columnData.id}
              contractStage={columnData.stage}
              columnData={columnData.fullData}
              location={this.props.location || ""}
              changePasswordLocation={this.props.changePasswordLocation || ""}
              forEdit={this.props.edit || ""}
              forChangePassword={this.props.changePassword || ""}
            />
          </TableCell>
        );
    }

    return columnCollection;
  };

  handleChangePage = (event, newPage) => {
    this.props.totalElements &&
      this.props.handleNextPage(newPage, this.state.rowsPerPage);
    this.setState({ page: newPage });
  };

  handleChangeRowsPerPage = event => {
    this.setState({ rowsPerPage: event.target.value, page: 0 });
  };
  componentDidMount(){
    if(this.props.rowsPerPage)
    this.setState({ rowsPerPage: this.props.rowsPerPage });
  }

  render() {
    const {
      headerRows,
      categoryRows,
      rowData,
      fetchingComplete = true
    } = this.props;
    let clickable = false;
    if (this.props.isClickable) {
      clickable = true;
    }
    return (
      <Paper className="masterTable" id="masterTableReport">
        <Table>
          {categoryRows && (
            <TableHead>{this.addSuperHeader(categoryRows)}</TableHead>
          )}
          <TableHead>{this.addHeaderRow(headerRows)}</TableHead>
          {fetchingComplete ? (
            <TableBody>
              {this.addDataRow(
                this.props.totalElements
                  ? this.sortData(rowData)
                  : this.sortData(rowData).slice(
                      this.state.page * this.state.rowsPerPage,
                      this.state.page * this.state.rowsPerPage +
                        this.state.rowsPerPage
                    ),
                headerRows,
                clickable
              )}
            </TableBody>
          ) : (
            <TableBody>
              <TableRow>
                <TableCell
                  align="center"
                  colSpan={Object.keys(headerRows).length}
                >
                  <Loader />
                </TableCell>
              </TableRow>
            </TableBody>
          )}
          <TableFooter>
            <TableRow key="pagination-row">
              <TablePagination
                rowsPerPageOptions={[50]}
                count={this.props.totalElements || rowData.length || 0}
                rowsPerPage={this.state.rowsPerPage}
                page={this.state.page}
                onChangePage={this.handleChangePage}
                onChangeRowsPerPage={this.handleChangeRowsPerPage}
              />
            </TableRow>
          </TableFooter>
        </Table>
      </Paper>
    );
  }
}

function mapStateToProps(state) {
  return {
    MainFarmId: state.FarmManagementReducer.MainFarmId
  };
}

export default connect(
  mapStateToProps,
  {}
)(withStyles(styles, { withTheme: true })(CreateTable));



// WEBPACK FOOTER //
// ./src/components/CreateTable.js